export default {
	name: 'BundlesView'
}